import React, { useEffect, useState, createElement } from 'react';
import { ArrowRightIcon, CheckCircleIcon, MousePointerClickIcon, SearchIcon, LayersIcon, PuzzleIcon, SmartphoneIcon, ZapIcon, ShieldCheckIcon, ChevronDownIcon, ChevronUpIcon, WrenchIcon } from 'lucide-react';
import { FinalCtaSection } from '../components/FinalCtaSection';
export function WordPressWebsitesPage() {
  const [openFaq, setOpenFaq] = useState<number | null>(0);
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'WordPress websites | Flexibel & SEO-vriendelijk | Noord';
    let metaDesc = document.querySelector('meta[name="description"]') as HTMLMetaElement;
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.name = 'description';
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = 'WordPress website laten maken? Flexibele, snelle en SEO-vriendelijke websites gebouwd in WordPress. Zelf beheerbaar, veilig en uitbreidbaar. Vraag een offerte aan.';
    // Open Graph meta tags
    const ogTags: Record<string, string> = {
      'og:title': 'WordPress websites | Flexibel & SEO-vriendelijk | Noord',
      'og:description': 'WordPress website laten maken? Flexibele, snelle en SEO-vriendelijke websites gebouwd in WordPress.',
      'og:type': 'website',
      'og:url': 'https://noorddigital.nl/wordpress-websites',
      'og:site_name': 'Noord Digital',
      'og:locale': 'nl_NL'
    };
    Object.entries(ogTags).forEach(([property, content]) => {
      let tag = document.querySelector(`meta[property="${property}"]`) as HTMLMetaElement;
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('property', property);
        document.head.appendChild(tag);
      }
      tag.content = content;
    });
  }, []);
  const scrollToContact = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('contact')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const toggleFaq = (index: number) => {
    setOpenFaq(openFaq === index ? null : index);
  };
  const faqs = [{
    q: 'Is WordPress veilig voor mijn bedrijf?',
    a: 'Ja, WordPress is zeer veilig mits het goed wordt onderhouden. Wij zorgen voor de juiste beveiligingsplugins, sterke wachtwoorden en regelmatige updates om jouw wordpress website optimaal te beveiligen tegen hackers.'
  }, {
    q: 'Kan ik zelf content aanpassen?',
    a: "Absoluut! Dat is de grootste kracht van een WordPress website laten maken. Het systeem is erg gebruiksvriendelijk. Na oplevering krijg je van ons uitleg zodat je zelf eenvoudig teksten, afbeeldingen en nieuwe pagina's kunt toevoegen."
  }, {
    q: 'Hoe snel is een WordPress website?',
    a: "Een wordpress website kan razendsnel zijn, mits goed gebouwd. Wij gebruiken lichte thema's, optimaliseren afbeeldingen en gebruiken snelle hosting en caching om ervoor te zorgen dat jouw site direct laadt."
  }, {
    q: 'Is WordPress goed voor SEO?',
    a: 'WordPress is van nature zeer SEO-vriendelijk. Met de juiste inrichting en plugins (zoals Yoast of RankMath) heb je volledige controle over je vindbaarheid. Elk wordpress webdesign dat wij opleveren is technisch geoptimaliseerd voor Google.'
  }];
  return <main className="pt-16 lg:pt-[72px]" data-id="element-3131" data-mp="7jm559rlrkde">
      {/* Hero Section */}
      <section className="relative py-20 lg:py-32 bg-navy-900 overflow-hidden" data-id="element-3132" data-mp="36yhg31vukg9r">
        <div className="absolute inset-0 pointer-events-none" data-id="element-3133" data-mp="370kh0gyjftt9">
          <div className="absolute -top-32 -right-32 w-[500px] h-[500px] rounded-full opacity-20 blur-3xl bg-accent" data-id="element-3134" data-mp="3b0uibgbdxw1s" />
          <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full opacity-10 blur-3xl bg-accent-light" data-id="element-3135" data-mp="3fxuorsc5d0tf" />
          <div className="absolute inset-0 opacity-[0.03]" style={{
          backgroundImage: 'radial-gradient(circle at 1px 1px, white 1px, transparent 0)',
          backgroundSize: '32px 32px'
        }} data-id="element-3136" data-mp="3kvwa6jx1pc82" />
        </div>

        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-3137" data-mp="2972nnlxdcbdb">
          {/* Breadcrumb */}
          <nav className="flex items-center justify-center gap-2 text-sm mb-8 animate-fade-in-up" data-id="element-3138" data-mp="2i5myy20lniri">
            <a href="#/" className="text-navy-400 hover:text-white transition-colors" data-id="element-3139" data-mp="2d6jryc1272gw">
              Home
            </a>
            <span className="text-navy-500" data-id="element-3140" data-mp="2s29jsqsxe9tj">/</span>
            <span className="text-accent-light font-medium" data-id="element-3141" data-mp="2n4znqsb16zwq">
              WordPress websites
            </span>
          </nav>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white mb-6 animate-fade-in-up" data-id="element-3142" data-mp="30v3452n8bze9">
            WordPress websites die groeien met je bedrijf
          </h1>
          <p className="text-lg lg:text-xl text-navy-200 max-w-2xl mx-auto mb-10 animate-fade-in-up-delay-1" data-id="element-3143" data-mp="3atiu32ait2m6">
            Flexibele, snelle en SEO-vriendelijke websites gebouwd in WordPress.
            De perfecte basis voor jouw online succes.
          </p>
          <div className="animate-fade-in-up-delay-2" data-id="element-3144" data-mp="3pf6feqsgmd6m">
            <a href="#contact" onClick={scrollToContact} className="inline-flex items-center gap-2 bg-accent hover:bg-accent-hover text-white font-bold px-8 py-4 rounded-button shadow-medium hover:shadow-card transition-all duration-200 text-lg" data-id="element-3145" data-mp="3uess8z4dlrew">
              Plan een gesprek
              <ArrowRightIcon className="w-5 h-5" data-id="element-3146" data-mp="36ogdb4apquet" />
            </a>
          </div>
        </div>
      </section>

      {/* Waarom WordPress Section */}
      <section className="py-24 bg-surface-muted" data-id="element-3147" data-mp="2wt4xeinkjh5h">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3148" data-mp="2wq908wjjowi3">
          <div className="text-center mb-16" data-id="element-3149" data-mp="31s82g33jtndg">
            <h2 className="text-3xl lg:text-4xl font-bold text-navy-900 mb-4" data-id="element-3150" data-mp="2nrngiy2c7bfq">
              Waarom een WordPress website laten maken?
            </h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-3151" data-mp="2rrz3ihi69nud">
              Meer dan 40% van alle websites wereldwijd draait op WordPress. En
              dat is niet voor niets.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-3152" data-mp="tiid26n5ovv8">
            <div className="bg-white p-8 rounded-card shadow-soft hover:shadow-medium transition-shadow" data-id="element-3153" data-mp="ol9sjzejcfqt">
              <div className="w-12 h-12 rounded-xl bg-accent-light flex items-center justify-center mb-6" data-id="element-3154" data-mp="jn8757tn04c6">
                <MousePointerClickIcon className="w-6 h-6 text-accent" data-id="element-3155" data-mp="1h8mdy68ymhij" />
              </div>
              <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-3156" data-mp="1cb448dn4by9h">
                Gebruiksvriendelijk
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-3157" data-mp="17d2nhzd60b16">
                Beheer zelf eenvoudig je teksten, afbeeldingen en blogartikelen
                zonder technische kennis.
              </p>
            </div>
            <div className="bg-white p-8 rounded-card shadow-soft hover:shadow-medium transition-shadow" data-id="element-3158" data-mp="3o03pltm1a5rm">
              <div className="w-12 h-12 rounded-xl bg-accent-light flex items-center justify-center mb-6" data-id="element-3159" data-mp="23icqbn9r1e6l">
                <SearchIcon className="w-6 h-6 text-accent" data-id="element-3160" data-mp="27imuqvhw7wjc" />
              </div>
              <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-3161" data-mp="2cirdyta6r5d9">
                SEO vriendelijk
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-3162" data-mp="2h9hgzzv52w4s">
                De code structuur van WordPress wordt perfect begrepen door
                Google voor betere vindbaarheid.
              </p>
            </div>
            <div className="bg-white p-8 rounded-card shadow-soft hover:shadow-medium transition-shadow" data-id="element-3163" data-mp="2r62m0l75s78m">
              <div className="w-12 h-12 rounded-xl bg-accent-light flex items-center justify-center mb-6" data-id="element-3164" data-mp="2v9ij1in549lu">
                <LayersIcon className="w-6 h-6 text-accent" data-id="element-3165" data-mp="307alv7pbpg4t" />
              </div>
              <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-3166" data-mp="10w9g69p3nmck">
                Flexibel uitbreidbaar
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-3167" data-mp="15uawwnz1z9kv">
                Begin klein en breid later eenvoudig uit met een webshop,
                reserveringssysteem of leeromgeving.
              </p>
            </div>
            <div className="bg-white p-8 rounded-card shadow-soft hover:shadow-medium transition-shadow" data-id="element-3168" data-mp="3hheh4475yces">
              <div className="w-12 h-12 rounded-xl bg-accent-light flex items-center justify-center mb-6" data-id="element-3169" data-mp="3cil2u9k1yhdk">
                <PuzzleIcon className="w-6 h-6 text-accent" data-id="element-3170" data-mp="2os78gcdzw6ft" />
              </div>
              <h3 className="text-xl font-bold text-navy-900 mb-3" data-id="element-3171" data-mp="2kr57nr4fjmbq">
                Veel integraties
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-3172" data-mp="2yrfzawdkd4xy">
                Koppel moeiteloos met je favoriete CRM, nieuwsbrief software of
                boekhoudpakket.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Wat je krijgt */}
      <section className="py-24 bg-white" data-id="element-3173" data-mp="91kztn50cwwo">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3174" data-mp="90jgkvdu943v">
          <div className="text-center mb-16" data-id="element-3175" data-mp="1qzhc8wm2mts9">
            <h2 className="text-3xl lg:text-4xl font-bold text-navy-900 mb-4" data-id="element-3176" data-mp="1qxo5zifdebks">
              Standaard inbegrepen bij elk project
            </h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-3177" data-mp="1hysxfzouspeb">
              Wanneer je kiest voor ons wordpress webdesign, krijg je altijd een
              compleet product.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-3178" data-mp="2amoux6m8ylc5">
            <div className="border border-navy-100 p-8 rounded-card flex items-start gap-5" data-id="element-3179" data-mp="2apkrormcz3z0">
              <div className="w-12 h-12 rounded-xl bg-navy-50 flex items-center justify-center flex-shrink-0" data-id="element-3180" data-mp="2eqms3bs0hm2k">
                <SmartphoneIcon className="w-6 h-6 text-navy-700" data-id="element-3181" data-mp="25wi738zk74uy" />
              </div>
              <div data-id="element-3182" data-mp="25u5fe4401g4p">
                <h3 className="text-xl font-bold text-navy-900 mb-2" data-id="element-3183" data-mp="2tmcirn856ndm">
                  Responsive design
                </h3>
                <p className="text-slate-600" data-id="element-3184" data-mp="2ydujca696ly2">
                  Jouw website werkt en oogt perfect op mobiel, tablet en
                  desktop. Cruciaal voor zowel gebruikerservaring als SEO.
                </p>
              </div>
            </div>
            <div className="border border-navy-100 p-8 rounded-card flex items-start gap-5" data-id="element-3185" data-mp="27mvm5e7bs8ug">
              <div className="w-12 h-12 rounded-xl bg-navy-50 flex items-center justify-center flex-shrink-0" data-id="element-3186" data-mp="1trjl6p2ktm53">
                <SearchIcon className="w-6 h-6 text-navy-700" data-id="element-3187" data-mp="1jzni0zlmv5u0" />
              </div>
              <div data-id="element-3188" data-mp="1jxkjfr6f04do">
                <h3 className="text-xl font-bold text-navy-900 mb-2" data-id="element-3189" data-mp="1oqdqilpcvosx">
                  SEO basis inrichting
                </h3>
                <p className="text-slate-600" data-id="element-3190" data-mp="1a29539yx4z6g">
                  We richten de technische SEO direct goed in en installeren
                  tools waarmee je zelf je vindbaarheid kunt optimaliseren.
                </p>
              </div>
            </div>
            <div className="border border-navy-100 p-8 rounded-card flex items-start gap-5" data-id="element-3191" data-mp="1135ku2o0mdqd">
              <div className="w-12 h-12 rounded-xl bg-navy-50 flex items-center justify-center flex-shrink-0" data-id="element-3192" data-mp="161p6e1yp5ni7">
                <ZapIcon className="w-6 h-6 text-navy-700" data-id="element-3193" data-mp="hezmsbyr4q6k" />
              </div>
              <div data-id="element-3194" data-mp="hh417nua17l3">
                <h3 className="text-xl font-bold text-navy-900 mb-2" data-id="element-3195" data-mp="veskwscly8ok">
                  Snelle laadtijd
                </h3>
                <p className="text-slate-600" data-id="element-3196" data-mp="rcxjlnuofvas">
                  Niemand houdt van wachten. We bouwen lichte websites en
                  gebruiken caching voor razendsnelle laadtijden.
                </p>
              </div>
            </div>
            <div className="border border-navy-100 p-8 rounded-card flex items-start gap-5" data-id="element-3197" data-mp="10dlp1u608nc2">
              <div className="w-12 h-12 rounded-xl bg-navy-50 flex items-center justify-center flex-shrink-0" data-id="element-3198" data-mp="1f1yl0r53e66k">
                <ShieldCheckIcon className="w-6 h-6 text-navy-700" data-id="element-3199" data-mp="1a5rotq2i091t" />
              </div>
              <div data-id="element-3200" data-mp="1o3porqg2o2xs">
                <h3 className="text-xl font-bold text-navy-900 mb-2" data-id="element-3201" data-mp="1o13h7qt6lnfk">
                  Beveiliging
                </h3>
                <p className="text-slate-600" data-id="element-3202" data-mp="gr72kbhabwuh">
                  Standaard voorzien van SSL-certificaat, anti-spam maatregelen
                  en beveiligingsplugins om hackers buiten de deur te houden.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* WordPress vs Andere systemen */}
      <section className="py-24 bg-navy-50" data-id="element-3203" data-mp="ujwrano77fva">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3204" data-mp="zhou4cqdsme9">
          <div className="text-center mb-16" data-id="element-3205" data-mp="zjj631jod467">
            <h2 className="text-3xl lg:text-4xl font-bold text-navy-900 mb-4" data-id="element-3206" data-mp="14g020hx48mtu">
              WordPress vergeleken
            </h2>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-3207" data-mp="19g4bvp3iqjb3">
              Waarom een wordpress website bedrijf vaak de beste keuze is.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12" data-id="element-3208" data-mp="3b7r39rrbog83">
            <div className="bg-white p-8 rounded-card shadow-card border-2 border-accent relative" data-id="element-3209" data-mp="3f8b1yzrjnrwc">
              <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-accent text-white text-xs font-bold px-4 py-1 rounded-full" data-id="element-3210" data-mp="37os2zk1wno24">
                Onze keuze
              </div>
              <h3 className="text-2xl font-bold text-navy-900 mb-4 text-center" data-id="element-3211" data-mp="32wiiwknh1i7r">
                WordPress
              </h3>
              <ul className="space-y-4" data-id="element-3212" data-mp="2ty6riges6ge9">
                <li className="flex items-start gap-3" data-id="element-3213" data-mp="2tz81ehk28wue">
                  <CheckCircleIcon className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-3214" data-mp="3qofqu0nsvq3l" />
                  <span className="text-slate-700" data-id="element-3215" data-mp="3lp2tun37t2na">
                    100% eigendom van je website
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-3216" data-mp="3hlocnt3jig89">
                  <CheckCircleIcon className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-3217" data-mp="3coeo0fnz68lh" />
                  <span className="text-slate-700" data-id="element-3218" data-mp="2682qmgsz8uqy">Eindeloos uitbreidbaar</span>
                </li>
                <li className="flex items-start gap-3" data-id="element-3219" data-mp="218zjmqtfsegc">
                  <CheckCircleIcon className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-3220" data-mp="217eph2b1axj0" />
                  <span className="text-slate-700" data-id="element-3221" data-mp="3p4vyhossaei8">
                    Beste voor SEO resultaten
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-3222" data-mp="3ty8oo3d42td3">
                  <CheckCircleIcon className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-3223" data-mp="3g6aj22ilzflo" />
                  <span className="text-slate-700" data-id="element-3224" data-mp="3k7mdclcfgp07">
                    Geen maandelijkse platformkosten
                  </span>
                </li>
              </ul>
            </div>

            <div className="bg-white p-8 rounded-card shadow-soft" data-id="element-3225" data-mp="gqdwo4tfrv72">
              <h3 className="text-2xl font-bold text-navy-900 mb-4 text-center" data-id="element-3226" data-mp="gnhz4hli38j5">
                Wix
              </h3>
              <ul className="space-y-4" data-id="element-3227" data-mp="7oxpe5xx4972">
                <li className="flex items-start gap-3" data-id="element-3228" data-mp="7nmihx96elbq">
                  <CheckCircleIcon className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-3229" data-mp="2nglkdvtdfrn8" />
                  <span className="text-slate-700" data-id="element-3230" data-mp="2sfexhn4qxgmv">
                    Makkelijk voor beginners
                  </span>
                </li>
                <li className="flex items-start gap-3 text-slate-400" data-id="element-3231" data-mp="2jxcu40iwssbk">
                  <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 text-red-400 font-bold" data-id="element-3232" data-mp="2fxc73rhqv8sw">
                    ✕
                  </span>
                  <span data-id="element-3233" data-mp="2tuhkkcjsf9y6">Je huurt de website (geen eigendom)</span>
                </li>
                <li className="flex items-start gap-3 text-slate-400" data-id="element-3234" data-mp="2oyadggfnnsen">
                  <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 text-red-400 font-bold" data-id="element-3235" data-mp="218y5tkzz7seg">
                    ✕
                  </span>
                  <span data-id="element-3236" data-mp="2axpxrt51ecpd">Beperkte SEO mogelijkheden</span>
                </li>
                <li className="flex items-start gap-3 text-slate-400" data-id="element-3237" data-mp="2azsvkzcfla4n">
                  <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 text-red-400 font-bold" data-id="element-3238" data-mp="2667w12v6w83c">
                    ✕
                  </span>
                  <span data-id="element-3239" data-mp="1diu3ri2fs0pk">Moeilijk te verhuizen</span>
                </li>
              </ul>
            </div>

            <div className="bg-white p-8 rounded-card shadow-soft" data-id="element-3240" data-mp="3dld6h11swohw">
              <h3 className="text-2xl font-bold text-navy-900 mb-4 text-center" data-id="element-3241" data-mp="3ijogbbs3iz04">
                Squarespace
              </h3>
              <ul className="space-y-4" data-id="element-3242" data-mp="3na4tqvvx2kmh">
                <li className="flex items-start gap-3" data-id="element-3243" data-mp="3nb6gvyq7ixkk">
                  <CheckCircleIcon className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-3244" data-mp="3rc87jr6261ax" />
                  <span className="text-slate-700" data-id="element-3245" data-mp="2ulzbcfsc57pt">
                    Mooie standaard templates
                  </span>
                </li>
                <li className="flex items-start gap-3 text-slate-400" data-id="element-3246" data-mp="2zlc5llljdh2f">
                  <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 text-red-400 font-bold" data-id="element-3247" data-mp="33m4egdqhxjy6">
                    ✕
                  </span>
                  <span data-id="element-3248" data-mp="38j4di4oxhmfs">Minder flexibel dan WordPress</span>
                </li>
                <li className="flex items-start gap-3 text-slate-400" data-id="element-3249" data-mp="ivwu0dh8q7kw">
                  <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 text-red-400 font-bold" data-id="element-3250" data-mp="ntyf13y88gz0">
                    ✕
                  </span>
                  <span data-id="element-3251" data-mp="t0dddgtxi6tg">Hoge maandelijkse kosten</span>
                </li>
                <li className="flex items-start gap-3 text-slate-400" data-id="element-3252" data-mp="t2fzhprynfsw">
                  <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 text-red-400 font-bold" data-id="element-3253" data-mp="o7u0km32ffpp">
                    ✕
                  </span>
                  <span data-id="element-3254" data-mp="f989u3nfwudu">Beperkte integraties NL markt</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="text-center" data-id="element-3255" data-mp="a8u6v00p4amo">
            <a href="#/kennisbank" className="inline-flex items-center gap-2 text-accent font-semibold hover:text-accent-hover transition-colors" data-id="element-3256" data-mp="5aj04y5p6g8o">
              Lees ons uitgebreide artikel: WordPress vs Wix
              <ArrowRightIcon className="w-4 h-4" data-id="element-3257" data-mp="1zn8vlkbprxi6" />
            </a>
          </div>
        </div>
      </section>

      {/* WordPress Onderhoud */}
      <section className="py-24 bg-white" data-id="element-3258" data-mp="1vl40eh5mastf">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3259" data-mp="2ewri8em6ecjn">
          <div className="bg-navy-900 rounded-3xl p-8 lg:p-12 text-center relative overflow-hidden" data-id="element-3260" data-mp="2ix1zwojbyrec">
            <div className="absolute inset-0 opacity-10" style={{
            backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
            backgroundSize: '24px 24px'
          }} data-id="element-3261" data-mp="256582zx8ae8c" />
            <WrenchIcon className="w-12 h-12 text-accent mx-auto mb-6 relative z-10" data-id="element-3262" data-mp="1va255rujybkc" />
            <h2 className="text-3xl font-bold text-white mb-4 relative z-10" data-id="element-3263" data-mp="204pnta2vkbr0">
              Zorgeloos WordPress Onderhoud
            </h2>
            <p className="text-navy-200 text-lg mb-8 max-w-2xl mx-auto relative z-10" data-id="element-3264" data-mp="1r5m3y3vvvsbg">
              Een WordPress website heeft regelmatig updates nodig om veilig en
              snel te blijven. Wij nemen dit technische beheer graag voor je uit
              handen.
            </p>
            <a href="#/hosting-onderhoud" className="inline-flex items-center gap-2 bg-white text-navy-900 hover:bg-navy-50 font-bold px-8 py-4 rounded-button shadow-soft transition-all duration-200 relative z-10" data-id="element-3265" data-mp="3vntzadedinim">
              Bekijk onze onderhoudspakketten
              <ArrowRightIcon className="w-5 h-5" data-id="element-3266" data-mp="3kja40ytndbz" />
            </a>
          </div>
        </div>
      </section>

      {/* Gerelateerde pagina's */}
      <section className="py-16 bg-surface-muted border-y border-navy-100" data-id="element-3267" data-mp="i7maqgify23j">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-3268" data-mp="d91a4fza1gek">
          <h3 className="text-lg font-semibold text-navy-900 mb-6" data-id="element-3269" data-mp="radpap6m5dze">
            Ontdek meer:
          </h3>
          <div className="flex flex-wrap justify-center gap-4" data-id="element-3270" data-mp="n80j5znyfe23">
            <a href="#/website-laten-maken" className="text-accent hover:text-accent-hover font-medium underline underline-offset-4" data-id="element-3271" data-mp="n6flw2a99h0j">
              Professionele website laten maken
            </a>
            <span className="text-navy-200 hidden sm:inline" data-id="element-3272" data-mp="1wcwwjee69zuc">•</span>
            <a href="#/wordpress-vs-wix" className="text-accent hover:text-accent-hover font-medium underline underline-offset-4" data-id="element-3273" data-mp="1relmp3nvnpc4">
              WordPress of Wix kiezen?
            </a>
            <span className="text-navy-200 hidden sm:inline" data-id="element-3274" data-mp="2145404vxzb4v">•</span>
            <a href="#/webdesign-alkmaar" className="text-accent hover:text-accent-hover font-medium underline underline-offset-4" data-id="element-3275" data-mp="1desz3h7ndp8d">
              Webdesign bureau Alkmaar
            </a>
            <span className="text-navy-200 hidden sm:inline" data-id="element-3276" data-mp="1mfr1xw6cnqpd">•</span>
            <a href="#/hosting-onderhoud" className="text-accent hover:text-accent-hover font-medium underline underline-offset-4" data-id="element-3277" data-mp="1idx6q3exbewl">
              Website onderhoud uitbesteden
            </a>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-24 bg-white" data-id="element-3278" data-mp="31claqts61tdl">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3279" data-mp="31bjw6fbxyor4">
          <div className="text-center mb-16" data-id="element-3280" data-mp="36beqksuxdwgx">
            <h2 className="text-3xl lg:text-4xl font-bold text-navy-900 mb-4" data-id="element-3281" data-mp="36d9bi7675ol0">
              Veelgestelde vragen over WordPress
            </h2>
          </div>

          <div className="space-y-4" data-id="element-3282" data-mp="2wcyvyfwow52o">
            {faqs.map((faq, index) => <div key={index} className="bg-surface-muted rounded-xl shadow-sm border border-navy-50 overflow-hidden" data-id="element-3283" data-mp="3k32z6m5yu2t5" data-mpi={index}>
                <button onClick={() => toggleFaq(index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-3284" data-mp="3p1e8mvscmbau">
                  <span className="font-bold text-navy-900" data-id="element-3285" data-mp="3fajkflvjl1mr">{faq.q}</span>
                  {openFaq === index ? <ChevronUpIcon className="w-5 h-5 text-accent flex-shrink-0" data-id="element-3286" data-mp="6uq53acy5w7a" /> : <ChevronDownIcon className="w-5 h-5 text-navy-400 flex-shrink-0" data-id="element-3287" data-mp="lj9ocn6qhvg6" />}
                </button>
                {openFaq === index && <div className="px-6 pb-5 text-slate-600 leading-relaxed" data-id="element-3288" data-mp="gkyjkqvaqb4t">
                    {faq.a}
                  </div>}
              </div>)}
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <FinalCtaSection data-id="element-3289" data-mp="2kxibab4d1ot" />
    </main>;
}